import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      // Hero Section
      greetings: 'Hello, I am',
      name: 'Suresh Amrutham',
      focusedOn: 'Focused on',
      japaneseLevel: 'JLPT N4 certified',
      
      titles: {
        backendDev: 'Backend Developer',
        fullstackDev: 'Full Stack Developer',
        techExplorer: 'Tech Explorer',
        npmCreator: 'NPM Package Creator',
        techResearcher: 'Tech Researcher',
        aiEnthusiast: 'AI Enthusiast',
        innovationEng: 'Innovation Engineer',
        dbEngineer: 'Database Engineer',
        solutionBuilder: 'Solution Builder',
        osContributor: 'Open Source Contributor'
      },

      accessibility: {
        profileImage: 'Suresh Amrutham',
        githubProfile: 'GitHub Profile',
        linkedinProfile: 'LinkedIn Profile'
      },

      // About Section
      about: {
        title: 'About Me',
        intro: "Hello! I'm Amrutham Suresh Kumar from Hyderabad, Telangana, India. Currently working as a Senior Software Engineer-II at Vanix Technologies, I bring 8 years of experience in developing global products.",
        expertise: "My expertise primarily lies in Backend Development, with 6+ years of hands-on experience in Node.js, MongoDB, and MySQL. I've also spent 2 valuable years in Research and Development, focusing on Indoor Navigation systems.",
        research: {
          title: 'Research Publications',
          papers: [
            '"Indoor Crowd Detection Using RGB Camera And IoT" - Published in IJESMR (International Journal Of Engineering Sciences & Management Research)',
            '"IoT Concept for Animal Detection Using ANN to Prevent Animal Vehicle Collision on Highways" - Published in International Journal of Science and Engineering Applications (IJSEA)'
          ]
        },
        certifications: {
          title: 'Certifications & Training',
          list: [
            'AWS Certified Developer – Associate (DVA-C01)',
            'Google Professional Cloud Developer',
            'MongoDB Basics - MongoDB University',
            'JLPT N4 Certification in Japanese Language'
          ]
        },
        highlights: {
          title: 'Key Highlights',
          list: [
            'Led development of microservices-based applications serving 100K+ daily users',
            'Published researcher in the field of IoT and Computer Vision',
            'Cross-cultural experience with Japanese language proficiency',
            'Specialized in Backend Development with Node.js, MongoDB, and MySQL',
            '2 years of R&D experience in Indoor Navigation Systems',
            'Reduced system response time by 40% through optimization'
          ]
        },
        technologies: {
          title: 'Core Technologies',
          list: ['Node.js', 'MongoDB', 'MySQL', 'AWS', 'IoT', 'Redis']
        },
        softSkills: {
          title: 'Soft Skills',
          list: [
            'Team Leadership',
            'Problem Solving',
            'Technical Writing',
            'Cross-cultural Communication',
            'Mentoring'
          ]
        }
      },
      experience: {
        title: 'Work Experience',
        subtitle: 'My professional journey',
        positions: [
          {
            title: 'Senior Software Engineer-II',
            company: 'Vanix Technologies',
            period: 'Oct 2024 - Present',
            location: 'Hyderabad, India',
            description: [
              'Lead backend development using Node.js and PostgreSQL, improving application performance by 40%',
              'Architect and manage database solutions using PostgreSQL and TimescaleDB',
              'Drive technical decisions and mentor junior developers in MEAN stack development',
              'Implement AWS infrastructure and establish development best practices',
              'Led the development and implementation of an in-house database migration solution, efficiently migrating over 9.8 million records across more than 60 tables to TimescaleDB. The migration was completed in 9.4 minutes, achieving a peak performance of 31,000 rows per second with zero data loss. Additionally, this project reduced AWS Data Miggration Service (DMS) costs by 70% and reduced AWS Redshift costS costs, achieving annual savings of $3,000',
              'Led comprehensive backend API planning and development, coordinating with Firmware, Web, and Mobile App teams to ensure seamless integration and optimal performance',
              'Established and maintained MCP JIRA Server infrastructure, implementing automated workflows and custom automation scripts to streamline project management processes',
              'Designed and implemented comprehensive AWS infrastructure including EC2, WAF, Load Balancer, and ALB with domain routing through NLB. Configured CloudWatch for monitoring, implemented Point-in-Time Recovery (PITR) for PostgreSQL databases, and established robust backup and recovery procedures',
              'Created Asset Tracking API implemented OSRM backend code and OpenStreetMap dataset on our own AWS server',
            ],
            techStack: {
              'Core': ['Node.js', 'Javascript', 'PostgreSQL', 'MySQL'],
              'Frontend': ['Angular'],
              'Cloud': ['AWS'],
              'Tools': ['Git']
            }
          },
          {
            title: 'Senior Software Engineer-II',
            company: 'ENGRO Technologies',
            period: 'May 2023 - Dec 2023',
            location: 'Hyderabad, India',
            description: [
              'Built ETL migration tool for SQL to MongoDB data transformation',
              'Developed subscription and payment system for OTT platform serving MENA, India, US, and UK',
              'Integrated multiple payment gateways including Adyen and Google Play',
              'Led successful AWS to GCP migration, optimizing performance for 13M+ records'
            ],
            techStack: {
              'Core': ['Node.js', 'MongoDB', 'MySQL'],
              'Cloud': ['AWS', 'GCP'],
              'Payment': ['Adyen (web)', 'In-App Purchase (iOS)', 'Google Play (Android)'],
              'Tools': ['Git']
            }
          },
          {
            title: 'Senior Software Engineer',
            company: 'Kore.AI',
            period: 'Oct 2020 - Sep 2022',
            location: 'Hyderabad, India',
            description: [
              'Developed Bank Assist Workbench on Kore.ai platform for banking workflow automation',
              'Created approval interface for HR and IT management systems',
              'Implemented DevOps processes and UI enhancements',
              'Served international clients across USA, UAE, and Japan'
            ],
            techStack: {
              'Core': ['Node.js', 'MongoDB', 'Redis'],
              'Platform': ['Kore.ai'],
              'Cloud': ['AWS'],
              'Tools': ['Git']
            }
          },
          {
            title: 'Node.js Back-end Developer',
            company: 'Terminal 2',
            period: 'April 2019 - Feb 2020',
            location: 'Hyderabad, India',
            description: [
              'Built E-commerce backend system using Node.js and MySQL',
              'Implemented REST APIs for product management',
              'Set up AWS infrastructure (EC2, RDS, S3)',
              'Created automated deployment pipeline using Bitbucket and AWS CodeDeploy'
            ],
            techStack: {
              'Core': ['Node.js', 'MySQL'],
              'Cloud': ['AWS EC2', 'RDS', 'S3', 'CodeDeploy'],
              'Tools': ['Bitbucket Pipeline']
            }
          },
          {
            title: 'Node.js Back-end Developer',
            company: 'Flappjacks',
            period: 'Dec 2018 - April 2019',
            location: 'Hyderabad, India',
            description: [
              'Developed backend for web and mobile applications using Node.js and MongoDB',
              'Created REST APIs for cross-platform integration',
              'Configured AWS infrastructure for production deployment',
              'Managed database operations and system maintenance'
            ],
            techStack: {
              'Core': ['Node.js', 'MongoDB', 'MySQL'],
              'Cloud': ['AWS'],
              'Tools': ['BitBucket']
            }
          },
          {
            title: 'Research Assistant',
            company: 'SRM Research Institute',
            period: 'Jan 2016 - Dec 2018',
            location: 'Chennai, India',
            description: [
              'Researched Indoor Navigation and Location Systems for IoT applications',
              'Implemented Precision Tracking using UWB technology',
              'Developed pathfinding algorithms for indoor navigation',
              'Published research findings in IoT and indoor positioning'
            ],
            techStack: {
              'Programming': ['JavaScript', 'Java', 'Node.js'],
              'Hardware': ['UWB', 'IoT Sensors'],
              'Research': ['Indoor Navigation', 'Location Systems']
            }
          }
        ]
      },
      skills: {
        title: 'Technical Skills',
        categories: {
          frontend: 'Frontend Development',
          backend: 'Backend Development',
          cloud: 'Cloud & DevOps',
          database: 'Database & Tools'
        }
      },
      projects: {
        title: 'Side Projects',
        subtitle: 'My Projects',
        viewProject: 'View Project',
        sourceCode: 'Source Code',
        liveDemo: 'Live Demo',
        projects: [
          {
            title: 'Japanese Grammar Learning Platform',
            subtitle: 'Interactive Web Application',
            description: 'An interactive web application for learning Japanese grammar patterns from the Minna no Nihongo textbook series. This application provides a user-friendly interface to explore grammar patterns with examples, translations, and illustrations.',
            features: [
              'Browse grammar patterns by lesson',
              'View Japanese example sentences with furigana',
              'See translations in English, Hindi, and Telugu',
              'Visual illustrations for each grammar pattern',
              'Responsive design for desktop and mobile devices',
              'Search functionality to find specific grammar patterns'
            ],
            tech: [
              'React',
              'Next.js',
              'Javascript',
              'Tailwind CSS',
              'Vercel',
              'i18n',
              'Framer Motion'
            ],
            demo: {
              web: 'https://japanese-grammar.vercel.app/'
            },
            github: 'https://github.com/suresh2291/japanese-grammar',
            isHighlighted: true
          },
          {
            title: 'Database Migration Tool',
            subtitle: 'MySQL to TimescaleDB Migration Utility',
            description: 'A powerful and flexible database migration tool that supports both generic database migrations and specialized TimescaleDB migrations. This tool enables seamless data transfer between different database systems with support for incremental synchronization and progress tracking.',
            features: [
              'Generic database migration support (MySQL, PostgreSQL)',
              'Specialized TimescaleDB migration capabilities',
              'Incremental data synchronization',
              'Progress tracking and checkpointing',
              'Detailed logging system',
              'Configurable migration processes',
              'Support for large-scale data migrations',
              'Zero data loss guarantee',
              'Performance optimization for bulk transfers'
            ],
            tech: [
              'Node.js',
              'Javascript',
              'MySQL',
              'PostgreSQL',
              'TimescaleDB',
              'Docker',
              'AWS DMS',
              'Data Validation'
            ],
            github: 'https://github.com/suresh2291/mysql-timescale-migrate',
            isHighlighted: true
          },
          {
            title: 'Photo Annotate',
            subtitle: 'Full Stack MERN Application',
            description: 'A comprehensive platform for sharing, annotating, and downloading images. It features advanced functionalities like user authentication, social features, and image enhancement.',
            features: [
              'Image annotation and download functionality',
              'Full-fledged user authentication system',
              'Social features (likes, comments, follow)',
              'Friend request system',
              'Profile management',
              'Dark/Light mode toggle'
            ],
            tech: [
              'JavaScript',
              'Node.js',
              'MongoDB',
              'React',
              'React-Konva',
              'AWS',
              'Cloudinary',
              'FastQ',
              'JWT',
              'Mongoose',
              'Multer',
              'Nodemailer',
              'Sharp'
            ],
            demo: {
              web: 'https://www.youtube.com/watch?v=cKUMCm4lB24',
              mobile: 'https://www.youtube.com/watch?v=wA3FKxYxkMw'
            },
            github: 'https://github.com/suresh2291/photoSharingApp',
            isHighlighted: true
          },
          {
            title: 'React Image Annotate Tool',
            subtitle: 'NPM Package',
            description: 'A React component published as an NPM package, providing comprehensive image annotation functionality with an intuitive user interface.',
            features: [
              'Image file selection functionality',
              'Multiple font options',
              'Text and circle size customization',
              'Color picker integration',
              'Text and circle annotations',
              'Freehand drawing tool',
              'Undo/Redo functionality',
              'Image download functionality',
              'Cross-browser compatibility'
            ],
            tech: [
              'React',
              'JavaScript',
              'NPM',
              'ReactKonva',
              'HTML5',
              'CSS3'
            ],
            links: {
              npm: 'https://www.npmjs.com/package/react-image-annotate-tool'
            },
            github: 'https://github.com/suresh2291/react-image-annomate',
            isHighlighted: true
          },
          {
            title: 'Database Migration Tool',
            subtitle: 'MySQL to MongoDB Migration Utility',
            description: 'A tool automating data transformation and transfer from MySQL to MongoDB. It handles data type conversion, relationship mapping, and data integrity checks, simplifying the migration process.',
            features: [
              'Automatic conversion of SQL to MongoDB schema',
              'Data type mapping and conversion',
              'Preservation of relationships between collections',
              'Configurable migration settings',
              'Progress tracking and logging',
              'Error handling and rollback functionality',
              'Support for large datasets',
              'No code changes required',
              'Detailed documentation and setup guide'
            ],
            tech: [
              'Node.js',
              'MySQL',
              'MongoDB',
              'JSON',
              'mongodb',
              'mysql',
              'SQL Parser',
              'Data Validation'
            ],
            github: 'https://github.com/suresh2291/datamigration',
            isHighlighted: true
          },
          {
            title: 'CoderByte Solutions',
            subtitle: 'JavaScript Algorithm Challenges',
            description: 'A comprehensive collection of JavaScript solutions to CoderByte programming challenges. It demonstrates problem-solving skills and algorithmic thinking, with detailed explanations and optimal approaches for each solution.',
            features: [
              'Array manipulation algorithms',
              'String processing solutions',
              'Mathematical problem implementations',
              'Data structure challenges',
              'Time complexity optimization',
              'Multiple solution approaches',
              'Clean code practices',
              'Performance considerations'
            ],
            tech: [
              'JavaScript',
              'Data Structures',
              'Algorithms',
              'Problem Solving',
              'ES6+',
              'Jest'
            ],
            github: 'https://github.com/suresh2291/coderByteJs',
            isHighlighted: true
          },
          {
            title: 'REST API Todo App',
            subtitle: 'Node.js Backend Application',
            description: 'A RESTful API implementation for a Todo application built using Node.js and Express. It demonstrates best practices in API design, authentication, and database integration, with comprehensive documentation.',
            features: [
              'RESTful API architecture',
              'Todo CRUD operations',
              'User authentication and authorization',
              'Input validation and sanitization',
              'Error handling middleware'
            ],
            tech: [
              'Node.js',
              'Express',
              'MongoDB',
              'JWT',
              'Mongoose',
              'bcrypt',
              'Swagger UI',
              'Jest'
            ],
            github: 'https://github.com/suresh2291/nodeJsTodoAPP',
            isHighlighted: true
          }
        ]
      },
      contact: {
        title: 'Hire Me',
        name: 'Amrutham Suresh Kumar',
        description: 'Feel free to reach out to me for any questions or opportunities.'
      },
      navigation: {
        menu: {
          home: 'Home',
          about: 'About',
          experience: 'Experience',
          skills: 'Skills',
          projects: 'Projects',
          contact: 'Hire Me'
        },
        language: {
          select: 'Select Language',
          en: 'English',
          ja: '日本語'
        },
        theme: {
          toggle: 'Toggle Theme',
          light: 'Light Mode',
          dark: 'Dark Mode'
        }
      }
    }
  },
  ja: {
    translation: {
      // Hero Section
      name: 'アムルタム・スレーシュ',
      greetings: 'みんなさん、こんにちは！',
      focusedOn: '<ruby>専門<rt>せんもん</rt></ruby><ruby>分野<rt>ぶんや</rt></ruby>',
      japaneseLevel: '<ruby>日本語<rt>にほんご</rt></ruby><ruby>能力<rt>のうりょく</rt></ruby><ruby>試験<rt>しけん</rt></ruby> N4 <ruby>合格<rt>ごうかく</rt></ruby>',
      
      titles: {
        backendDev: 'バックエンド<ruby>開発<rt>かいはつ</rt></ruby>',
        fullstackDev: 'フルスタック<ruby>開発<rt>かいはつ</rt></ruby>',
        techExplorer: '<ruby>技術<rt>ぎじゅつ</rt></ruby><ruby>探求<rt>たんきゅう</rt></ruby>',
        npmCreator: 'パッケージ<ruby>開発<rt>かいはつ</rt></ruby>',
        techResearcher: '<ruby>技術<rt>ぎじゅつ</rt></ruby><ruby>研究<rt>けんきゅう</rt></ruby>',
        aiEnthusiast: 'AI <ruby>技術<rt>ぎじゅつ</rt></ruby>',
        innovationEng: '<ruby>革新<rt>かくしん</rt></ruby><ruby>技術<rt>ぎじゅつ</rt></ruby>',
        dbEngineer: 'データベース',
        solutionBuilder: '<ruby>課題<rt>かだい</rt></ruby><ruby>解決<rt>かいけつ</rt></ruby>',
        osContributor: 'オープンソース'
      },

      accessibility: {
        profileImage: 'アムルタム・スレーシュ',
        githubProfile: 'GitHub <ruby>プロフィール<rt>ぷろふぃーる</rt></ruby>',
        linkedinProfile: 'LinkedIn <ruby>プロフィール<rt>ぷろふぃーる</rt></ruby>'
      },

      // About Section
      about: {
        title: '<ruby>自己<rt>じこ</rt></ruby><ruby>紹介<rt>しょうかい</rt></ruby>',
        intro: "<ruby>初<rt>はじ</rt></ruby>めまして。アムルタム・スレーシュと<ruby>申<rt>もう</rt></ruby>します。インド<ruby>出身<rt>しゅっしん</rt></ruby>でございます。<ruby>出身地<rt>しゅっしんち</rt></ruby>はテランガーナ<ruby>州<rt>しゅう</rt></ruby>ハイデラバードでございます。<ruby>現在<rt>げんざい</rt></ruby>、Vanix Technologiesにて<ruby>上級<rt>じょうきゅう</rt></ruby>ソフトウェアエンジニアとして<ruby>勤務<rt>きんむ</rt></ruby>させていただいております。",
        expertise: "ソフトウェアエンジニアとして8<ruby>年間<rt>ねんかん</rt></ruby>、その<ruby>内訳<rt>うちわけ</rt></ruby>として<ruby>研究<rt>けんきゅう</rt></ruby><ruby>開発<rt>かいはつ</rt></ruby>エンジニアとして2<ruby>年間<rt>ねんかん</rt></ruby>、そしてNode.js、MongoDB、AWSを<ruby>使用<rt>しよう</rt></ruby>してグローバル<ruby>製品<rt>せいひん</rt></ruby>のバックエンド<ruby>開発<rt>かいはつ</rt></ruby>として6<ruby>年間<rt>ねんかん</rt></ruby>の<ruby>経験<rt>けいけん</rt></ruby>がございます。どうぞよろしくお<ruby>願<rt>ねが</rt></ruby>い<ruby>申<rt>もう</rt></ruby>し<ruby>上<rt>あ</rt></ruby>げます。",
        research: {
          title: '<ruby>研究<rt>けんきゅう</rt></ruby><ruby>論文<rt>ろんぶん</rt></ruby>',
          papers: [
            'IJESMR（<ruby>工学<rt>こうがく</rt></ruby><ruby>科学<rt>かがく</rt></ruby><ruby>管理<rt>かんり</rt></ruby><ruby>研究<rt>けんきゅう</rt></ruby>の<ruby>国際<rt>こくさい</rt></ruby>ジャーナル）に<ruby>掲載<rt>けいさい</rt></ruby>された「RGB<ruby>カメラ</ruby>とIoTを<ruby>使用<rt>しよう</rt></ruby>した<ruby>屋内<rt>おくない</rt></ruby><ruby>群衆<rt>ぐんしゅう</rt></ruby><ruby>検知<rt>けんち</rt></ruby>」',
            '<ruby>国際<rt>こくさい</rt></ruby><ruby>科学<rt>かがく</rt></ruby><ruby>工学<rt>こうがく</rt></ruby>アプリケーションジャーナル（IJSEA）に<ruby>掲載<rt>けいさい</rt></ruby>された「ANNを<ruby>使用<rt>しよう</rt></ruby>した<ruby>動物<rt>どうぶつ</rt></ruby><ruby>検知<rt>けんち</rt></ruby>による<ruby>高速道路<rt>こうそくどうろ</rt></ruby>での<ruby>動物<rt>どうぶつ</rt></ruby><ruby>車両<rt>しゃりょう</rt></ruby><ruby>衝突<rt>しょうとつ</rt></ruby><ruby>防止<rt>ぼうし</rt></ruby>のためのIoTコンセプト」'
          ]
        },
        certifications: {
          title: '<ruby>資格<rt>しかく</rt></ruby>・<ruby>研修<rt>けんしゅう</rt></ruby>',
          list: [
            'AWS <ruby>認定<rt>にんてい</rt></ruby>デベロッパー – アソシエイト (DVA-C01)',
            'Google プロフェッショナル クラウド デベロッパー',
            'MongoDB Basics - MongoDB University',
            '<ruby>日本語<rt>にほんご</rt></ruby><ruby>能力<rt>のうりょく</rt></ruby><ruby>試験<rt>しけん</rt></ruby> N4 <ruby>合格<rt>ごうかく</rt></ruby>'
          ]
        },
        highlights: {
          title: '<ruby>主<rt>おも</rt></ruby>な<ruby>実績<rt>じっせき</rt></ruby>',
          list: [
            '<ruby>日間<rt>にちかん</rt></ruby>10<ruby>万人<rt>まんにん</rt></ruby><ruby>以上<rt>いじょう</rt></ruby>のユーザーに<ruby>対応<rt>たいおう</rt></ruby>するマイクロサービスベースのアプリケーション<ruby>開発<rt>かいはつ</rt></ruby>をリード',
            'IoTと<ruby>画像処理<rt>がぞうしょり</rt></ruby><ruby>分野<rt>ぶんや</rt></ruby>での<ruby>研究<rt>けんきゅう</rt></ruby><ruby>論文<rt>ろんぶん</rt></ruby>を<ruby>発表<rt>はっぴょう</rt></ruby>',
            '<ruby>日本語<rt>にほんご</rt></ruby><ruby>能力<rt>のうりょく</rt></ruby>を<ruby>活<rt>い</rt></ruby>かした<ruby>異文化<rt>いぶんか</rt></ruby>コミュニケーション<ruby>経験<rt>けいけん</rt></ruby>',
            'Node.js、MongoDB、MySQLを<ruby>使用<rt>しよう</rt></ruby>したバックエンド<ruby>開発<rt>かいはつ</rt></ruby>の<ruby>専門<rt>せんもん</rt></ruby><ruby>知識<rt>ちしき</rt></ruby>',
            '2<ruby>年間<rt>ねんかん</rt></ruby>の<ruby>研究<rt>けんきゅう</rt></ruby><ruby>開発<rt>かいはつ</rt></ruby><ruby>経験<rt>けいけん</rt></ruby>を<ruby>活<rt>い</rt></ruby>かした<ruby>屋内<rt>おくない</rt></ruby>ナビゲーションシステム',
            'システム<ruby>応答<rt>おうとう</rt></ruby><ruby>時間<rt>じかん</rt></ruby>を40%<ruby>削減<rt>さくげん</rt></ruby>する<ruby>最適化<rt>さいてきか</rt></ruby>を<ruby>実現<rt>じつげん</rt></ruby>'
          ]
        },
        technologies: {
          title: '<ruby>主要<rt>しゅよう</rt></ruby><ruby>技術<rt>ぎじゅつ</rt></ruby>',
          list: ['Node.js', 'MongoDB', 'MySQL', 'AWS', 'IoT', 'Redis']
        },
        softSkills: {
          title: '<ruby>業務<rt>ぎょうむ</rt></ruby>スキル',
          list: [
            'チーム<ruby>リーダーシップ</ruby>',
            '<ruby>問題<rt>もんだい</rt></ruby><ruby>解決<rt>かいけつ</rt></ruby><ruby>能力<rt>のうりょく</rt></ruby>',
            '<ruby>技術<rt>ぎじゅつ</rt></ruby><ruby>文書<rt>ぶんしょ</rt></ruby><ruby>作成<rt>さくせい</rt></ruby>',
            '<ruby>異文化<rt>いぶんか</rt></ruby>コミュニケーション',
            'メンタリング<ruby>経験<rt>けいけん</rt></ruby>'
          ]
        }
      },
      experience: {
        title: '<ruby>職務<rt>しょくむ</rt></ruby><ruby>経歴<rt>けいれき</rt></ruby>',
        subtitle: '<ruby>私<rt>わたし</rt></ruby>のキャリア',
        positions: [
          {
            title: '<ruby>上級<rt>じょうきゅう</rt></ruby>ソフトウェアエンジニア-II',
            company: 'Vanix Technologies',
            period: '2024<ruby>年<rt>ねん</rt></ruby>10<ruby>月<rt>がつ</rt></ruby> - <ruby>現在<rt>げんざい</rt></ruby>',
            location: 'インド、ハイデラバード',
            description: [
              'Node.jsとPostgreSQLを<ruby>用<rt>もち</rt></ruby>いたバックエンド<ruby>開発<rt>かいはつ</rt></ruby>を<ruby>主導<rt>しゅどう</rt></ruby>し、アプリケーション<ruby>性能<rt>せいのう</rt></ruby>を40%<ruby>向上<rt>こうじょう</rt></ruby>',
              'PostgreSQLとTimescaleDBを<ruby>活用<rt>かつよう</rt></ruby>したデータベース<ruby>設計<rt>せっけい</rt></ruby>と<ruby>管理<rt>かんり</rt></ruby>を<ruby>担当<rt>たんとう</rt></ruby>',
              'MEAN<ruby>技術<rt>ぎじゅつ</rt></ruby>スタックにおける<ruby>技術<rt>ぎじゅつ</rt></ruby><ruby>指導<rt>しどう</rt></ruby>と<ruby>若手<rt>わかて</rt></ruby><ruby>開発者<rt>かいはつしゃ</rt></ruby>の<ruby>育成<rt>いくせい</rt></ruby>',
              'AWS<ruby>基盤<rt>きばん</rt></ruby>の<ruby>構築<rt>こうちく</rt></ruby>と<ruby>開発<rt>かいはつ</rt></ruby><ruby>手法<rt>しゅほう</rt></ruby>の<ruby>確立<rt>かくりつ</rt></ruby>',
              '<ruby>社内<rt>しゃない</rt></ruby><ruby>データベース<rt>でーたべーす</rt></ruby><ruby>移行<rt>いこう</rt></ruby><ruby>ソリューション<rt>そりゅーしょん</rt></ruby>を<ruby>主導<rt>しゅどう</rt></ruby>し、<ruby>9.8</ruby><ruby>百万<rt>ひゃくまん</rt></ruby><ruby>件<rt>けん</rt></ruby>を<ruby>超<rt>こ</rt></ruby>える<ruby>レコード<rt>れこーど</rt></ruby>を<ruby>60<rt>ごじゅう</rt></ruby><ruby>以上<rt>いじょう</rt></ruby>の<ruby>テーブル<rt>てーぶる</rt></ruby>からTimescaleDBに<ruby>効率的<rt>こうりつてき</rt></ruby>に<ruby>移行<rt>いこう</rt></ruby>いたしました。<ruby>9.4<rt>きゅうてんよん</rt></ruby><ruby>分<rt>ふん</rt></ruby>で<ruby>完了<rt>かんりょう</rt></ruby>し、<ruby>秒<rt>びょう</rt></ruby><ruby>間<rt>かん</rt></ruby><ruby>31,000<rt>さんまんせん</rt></ruby><ruby>行<rt>ぎょう</rt></ruby>の<ruby>ピーク<rt>ぴーく</rt></ruby><ruby>性能<rt>せいのう</rt></ruby>を<ruby>達成<rt>たっせい</rt></ruby>し、<ruby>データ<rt>でーた</rt></ruby><ruby>損失<rt>そんしつ</rt></ruby>ゼロを<ruby>実現<rt>じつげん</rt></ruby>いたしました。また、AWS DMSの<ruby>費用<rt>ひよう</rt></ruby>を<ruby>削減<rt>さくげん</rt></ruby>し、<ruby>年間<rt>ねんかん</rt></ruby>$3,000の<ruby>節約<rt>せつやく</rt></ruby>を<ruby>達成<rt>たっせい</rt></ruby>いたしました。',
              '<ruby>ファームウェア<rt>ふぁーむうぇあ</rt></ruby>、<ruby>ウェブ<rt>うぇぶ</rt></ruby>、<ruby>モバイル<rt>もばいる</rt></ruby><ruby>アプリ<rt>あぷり</rt></ruby><ruby>チーム<rt>ちーむ</rt></ruby>と<ruby>連携<rt>れんけい</rt></ruby>し、<ruby>バックエンド<rt>ばっくえんど</rt></ruby>APIの<ruby>設計<rt>せっけい</rt></ruby>・<ruby>開発<rt>かいはつ</rt></ruby>を<ruby>主導<rt>しゅどう</rt></ruby>いたしました。<ruby>各<rt>かく</rt></ruby><ruby>チーム<rt>ちーむ</rt></ruby>との<ruby>密接<rt>みっせつ</rt></ruby>な<ruby>協力<rt>きょうりょく</rt></ruby>により、<ruby>シームレス<rt>しーむれす</rt></ruby>な<ruby>統合<rt>とうごう</rt></ruby>と<ruby>最適<rt>さいてき</rt></ruby>な<ruby>パフォーマンス<rt>ぱふぉーまんす</rt></ruby>を<ruby>実現<rt>じつげん</rt></ruby>いたしました。',
              'MCP JIRA<ruby>サーバー</rt></ruby>の<ruby>構築<rt>こうちく</rt></ruby>・<ruby>運用<rt>うんよう</rt></ruby>を<ruby>担当<rt>たんとう</rt></ruby>し、<ruby>プロジェクト<rt>ぷろじぇくと</rt></ruby><ruby>管理<rt>かんり</rt></ruby><ruby>工程<rt>こうてい</rt></ruby>を<ruby>効率化<rt>こうりつか</rt></ruby>するための<ruby>自動化<rt>じどうか</rt></ruby><ruby>ワークフロー<rt>わーくふろー</rt></ruby>と<ruby>カスタム<rt>かすたむ</rt></ruby><ruby>スクリプト<rt>すくりぷと</rt></ruby>を<ruby>実装<rt>じっそう</rt></ruby>いたしました。<ruby>これ<rt>これ</rt></ruby>により、<ruby>チーム<rt>ちーむ</rt></ruby>の<ruby>生産性<rt>せいさんせい</rt></ruby><ruby>向上<rt>こうじょう</rt></ruby>に<ruby>貢献<rt>こうけん</rt></ruby>いたしました。',
              'EC2、WAF、<ruby>負荷分散<rt>ふかぶんさん</rt></ruby>、NLBを<ruby>通<rt>とお</rt></ruby>した<ruby>ドメイン<rt>どめいん</rt></ruby><ruby>ルーティング<rt>るーてぃんぐ</rt></ruby>を<ruby>含<rt>ふく</rt></ruby>む<ruby>包括的<rt>ほうかつてき</rt></ruby>なAWS<ruby>基盤<rt>きばん</rt></ruby>を<ruby>設計<rt>せっけい</rt></ruby>・<ruby>構築<rt>こうちく</rt></ruby>いたしました。CloudWatchによる<ruby>監視<rt>かんし</rt></ruby>システムの<ruby>構築<rt>こうちく</rt></ruby>、PostgreSQL<ruby>データベース<rt>でーたべーす</rt></ruby>の<ruby>特定<rt>とくてい</rt></ruby><ruby>時点<rt>じてん</rt></ruby><ruby>復旧<rt>ふっきゅう</rt></ruby>（PITR）の<ruby>実装<rt>じっそう</rt></ruby>、<ruby>堅牢<rt>けんろう</rt></ruby>な<ruby>バックアップ<rt>ばっくあっぷ</rt></ruby>と<ruby>復旧<rt>ふっきゅう</rt></ruby>プロセスの<ruby>確立<rt>かくりつ</rt></ruby>を<ruby>担当<rt>たんとう</rt></ruby>いたしました。',
              '<ruby>資産<rt>しさん</rt></ruby><ruby>追跡<rt>ついせき</rt></ruby>APIを<ruby>作成<rt>さくせい</rt></ruby>し、OSRM<ruby>バックエンド<rt>ばっくえんど</rt></ruby>コードとOpenStreetMap<ruby>データセット<rt>でーたせっと</rt></ruby>を<ruby>自社<rt>じしゃ</rt></ruby>のAWS<ruby>サーバー<rt>さーばー</rt></ruby>に<ruby>実装<rt>じっそう</rt></ruby>いたしました。',
            ],
            techStack: {
              '<ruby>主要<rt>しゅよう</rt></ruby><ruby>技術<rt>ぎじゅつ</rt></ruby>': ['Node.js', 'Javascript', 'PostgreSQL', 'MySQL'],
              'フロントエンド': ['Angular'],
              'クラウド': ['AWS'],
              'ツール': ['Git', 'Docker']
            }
          },
          {
            title: '<ruby>上級<rt>じょうきゅう</rt></ruby>ソフトウェアエンジニア-II',
            company: 'ENGRO Technologies',
            period: '2023<ruby>年<rt>ねん</rt></ruby>5<ruby>月<rt>がつ</rt></ruby> - 2023<ruby>年<rt>ねん</rt></ruby>12<ruby>月<rt>がつ</rt></ruby>',
            location: 'インド、ハイデラバード',
            description: [
              'SQLからMongoDBへのデータ<ruby>移行<rt>いこう</rt></ruby>のためのETL<ruby>移行<rt>いこう</rt></ruby>ツールを<ruby>開発<rt>かいはつ</rt></ruby>',
              '<ruby>複数<rt>ふくすう</rt></ruby><ruby>地域<rt>ちいき</rt></ruby>（MENA、インド、アメリカ、イギリス）<ruby>向<rt>む</rt></ruby>けのOTT<ruby>配信<rt>はいしん</rt></ruby><ruby>課金<rt>かきん</rt></ruby>システムを<ruby>構築<rt>こうちく</rt></ruby>',
              'Adyen、Google Play<ruby>等<rt>とう</rt></ruby>の<ruby>決済<rt>けっさい</rt></ruby>システムを<ruby>統合<rt>とうごう</rt></ruby>',
              'AWSからGCPへの<ruby>移行<rt>いこう</rt></ruby>を<ruby>実現<rt>じつげん</rt></ruby>し、1300<ruby>万<rt>まん</rt></ruby><ruby>件以上<rt>けんいじょう</rt></ruby>のデータ<ruby>処理<rt>しょり</rt></ruby>を<ruby>最適化<rt>さいてきか</rt></ruby>'
            ],
            techStack: {
              '<ruby>主要<rt>しゅよう</rt></ruby><ruby>技術<rt>ぎじゅつ</rt></ruby>': ['Node.js', 'MongoDB', 'MySQL'],
              'クラウド': ['AWS', 'GCP'],
              '<ruby>決済<rt>けっさい</rt></ruby>': ['Adyen (web)', 'In-App Purchase (iOS)', 'Google Play (Android)'],
              'ツール': ['Git']
            }
          },
          {
            title: '<ruby>上級<rt>じょうきゅう</rt></ruby>ソフトウェアエンジニア',
            company: 'Kore.AI',
            period: '2020<ruby>年<rt>ねん</rt></ruby>10<ruby>月<rt>がつ</rt></ruby> - 2022<ruby>年<rt>ねん</rt></ruby>9<ruby>月<rt>がつ</rt></ruby>',
            location: 'インド、ハイデラバード',
            description: [
              'Kore.ai<ruby>上<rt>じょう</rt></ruby>で<ruby>銀行<rt>ぎんこう</rt></ruby><ruby>業務<rt>ぎょうむ</rt></ruby><ruby>自動化<rt>じどうか</rt></ruby>のためのBank Assist Workbenchを<ruby>開発<rt>かいはつ</rt></ruby>',
              'HR・IT<ruby>管理<rt>かんり</rt></ruby>システムの<ruby>承認<rt>しょうにん</rt></ruby><ruby>機能<rt>きのう</rt></ruby>を<ruby>実装<rt>じっそう</rt></ruby>',
              'DevOps<ruby>工程<rt>こうてい</rt></ruby>の<ruby>改善<rt>かいぜん</rt></ruby>とUI<ruby>最適化<rt>さいてきか</rt></ruby>を<ruby>担当<rt>たんとう</rt></ruby>',
              '<ruby>国際<rt>こくさい</rt></ruby><ruby>顧客<rt>こきゃく</rt></ruby>（米国、UAE、日本）への<ruby>技術<rt>ぎじゅつ</rt></ruby><ruby>支援<rt>しえん</rt></ruby>'
            ],
            techStack: {
              '<ruby>主要<rt>しゅよう</rt></ruby><ruby>技術<rt>ぎじゅつ</rt></ruby>': ['Node.js', 'MongoDB', 'Redis'],
              'プラットフォーム': ['Kore.ai'],
              'クラウド': ['AWS'],
              'ツール': ['Git', 'Jenkins']
            }
          },
          {
            title: 'Node.jsバックエンド<ruby>開発<rt>かいはつ</rt></ruby><ruby>者<rt>しゃ</rt></ruby>',
            company: 'Terminal 2',
            period: '2019<ruby>年<rt>ねん</rt></ruby>4<ruby>月<rt>がつ</rt></ruby> - 2020<ruby>年<rt>ねん</rt></ruby>2<ruby>月<rt>がつ</rt></ruby>',
            location: 'インド、ハイデラバード',
            description: [
              'Node.jsとMySQLを<ruby>用<rt>もち</rt></ruby>いたEコマースバックエンドシステムを<ruby>構築<rt>こうちく</rt></ruby>',
              '<ruby>商品<rt>しょうひん</rt></ruby><ruby>管理<rt>かんり</rt></ruby>のためのREST APIを<ruby>設計<rt>せっけい</rt></ruby>・<ruby>実装<rt>じっそう</rt></ruby>',
              'AWS<ruby>環境<rt>かんきょう</rt></ruby>（EC2、RDS、S3）の<ruby>構築<rt>こうちく</rt></ruby>と<ruby>運用<rt>うんよう</rt></ruby>',
              'BitbucketとAWS CodeDeployを<ruby>用<rt>もち</rt></ruby>いた<ruby>自動<rt>じどう</rt></ruby><ruby>デプロイ<rt>でぷろい</rt></ruby>の<ruby>実現<rt>じつげん</rt></ruby>'
            ],
            techStack: {
              '<ruby>主要<rt>しゅよう</rt></ruby><ruby>技術<rt>ぎじゅつ</rt></ruby>': ['Node.js', 'MySQL'],
              'クラウド': ['AWS EC2', 'RDS', 'S3', 'CodeDeploy'],
              'ツール': ['Bitbucket Pipeline']
            }
          },
          {
            title: 'Node.jsバックエンド<ruby>開発<rt>かいはつ</rt></ruby><ruby>者<rt>しゃ</rt></ruby>',
            company: 'Flappjacks',
            period: '2018<ruby>年<rt>ねん</rt></ruby>12<ruby>月<rt>がつ</rt></ruby> - 2019<ruby>年<rt>ねん</rt></ruby>4<ruby>月<rt>がつ</rt></ruby>',
            location: 'インド、ハイデラバード',
            description: [
              'Node.jsとMongoDBを<ruby>活用<rt>かつよう</rt></ruby>したウェブ・モバイルアプリケーションの<ruby>開発<rt>かいはつ</rt></ruby>',
              'クロスプラットフォーム<ruby>対応<rt>たいおう</rt></ruby>のREST APIを<ruby>設計<rt>せっけい</rt></ruby>・<ruby>実装<rt>じっそう</rt></ruby>',
              '<ruby>本番<rt>ほんばん</rt></ruby><ruby>環境<rt>かんきょう</rt></ruby>のAWS<ruby>基盤<rt>きばん</rt></ruby><ruby>構築<rt>こうちく</rt></ruby>と<ruby>管理<rt>かんり</rt></ruby>',
              'データベース<ruby>運用<rt>うんよう</rt></ruby>とシステム<ruby>保守<rt>ほしゅ</rt></ruby>の<ruby>最適化<rt>さいてきか</rt></ruby>'
            ],
            techStack: {
              '<ruby>主要<rt>しゅよう</rt></ruby><ruby>技術<rt>ぎじゅつ</rt></ruby>': ['Node.js', 'MongoDB', 'MySQL'],
              'クラウド': ['AWS'],
              'ツール': ['BitBucket']
            }
          },
          {
            title: '<ruby>研究<rt>けんきゅう</rt></ruby><ruby>助手<rt>じょしゅ</rt></ruby>',
            company: 'SRM Research Institute',
            period: '2016<ruby>年<rt>ねん</rt></ruby>1<ruby>月<rt>がつ</rt></ruby> - 2018<ruby>年<rt>ねん</rt></ruby>12<ruby>月<rt>がつ</rt></ruby>',
            location: 'インド、チェンナイ',
            description: [
              'IoT<ruby>技術<rt>ぎじゅつ</rt></ruby>を<ruby>応用<rt>おうよう</rt></ruby>した<ruby>屋内<rt>おくない</rt></ruby>ナビゲーション・<ruby>位置<rt>いち</rt></ruby><ruby>測位<rt>そくい</rt></ruby>システムの<ruby>研究<rt>けんきゅう</rt></ruby>',
              'UWB<ruby>技術<rt>ぎじゅつ</rt></ruby>を<ruby>用<rt>もち</rt></ruby>いた<ruby>高精度<rt>こうせいど</rt></ruby><ruby>位置<rt>いち</rt></ruby><ruby>追跡<rt>ついせき</rt></ruby>システムの<ruby>開発<rt>かいはつ</rt></ruby>',
              '<ruby>屋内<rt>おくない</rt></ruby>ナビゲーションの<ruby>経路<rt>けいろ</rt></ruby><ruby>探索<rt>たんさく</rt></ruby>アルゴリズムの<ruby>研究<rt>けんきゅう</rt></ruby>と<ruby>実装<rt>じっそう</rt></ruby>',
              '<ruby>研究<rt>けんきゅう</rt></ruby><ruby>成果<rt>せいか</rt></ruby>の<ruby>論文<rt>ろんぶん</rt></ruby><ruby>執筆<rt>しっぴつ</rt></ruby>と<ruby>学会<rt>がっかい</rt></ruby><ruby>発表<rt>はっぴょう</rt></ruby>'
            ],
            techStack: {
              '<ruby>開発<rt>かいはつ</rt></ruby><ruby>言語<rt>げんご</rt></ruby>': ['JavaScript', 'Java', 'Node.js'],
              'ハードウェア': ['UWB', 'IoT<ruby>センサー</ruby>'],
              '<ruby>研究<rt>けんきゅう</rt></ruby><ruby>分野<rt>ぶんや</rt></ruby>': ['<ruby>屋内<rt>おくない</rt></ruby>ナビゲーション', '<ruby>位置<rt>いち</rt></ruby><ruby>測位<rt>そくい</rt></ruby>システム']
            }
          }
        ]
      },
      skills: {
        title: '<ruby>技術<rt>ぎじゅつ</rt></ruby><ruby>専門<rt>せんもん</rt></ruby><ruby>分野<rt>ぶんや</rt></ruby>',
        categories: {
          frontend: '<ruby>フロントエンド</ruby><ruby>開発<rt>かいはつ</rt></ruby>',
          backend: '<ruby>バックエンド</ruby><ruby>開発<rt>かいはつ</rt></ruby>',
          cloud: '<ruby>クラウド</ruby>・<ruby>インフラ</ruby><ruby>基盤<rt>きばん</rt></ruby>',
          database: '<ruby>データベース</ruby>・<ruby>開発<rt>かいはつ</rt></ruby><ruby>ツール</ruby>'
        }
      },
      projects: {
        title: '<ruby>個人<rt>こじん</rt></ruby><ruby>開発<rt>かいはつ</rt></ruby>',
        subtitle: '<ruby>私<rt>わたし</rt></ruby>の<ruby>作品<rt>さくひん</rt></ruby>',
        viewProject: '<ruby>詳細<rt>しょうさい</rt></ruby>を<ruby>見<rt>み</rt></ruby>る',
        sourceCode: '<ruby>ソースコード</ruby>',
        liveDemo: '<ruby>実行<rt>じっこう</rt>デモ</ruby>',
        projects: [
          {
            title: '<ruby>日本語<rt>にほんご</rt></ruby><ruby>文法<rt>ぶんぽう</rt></ruby><ruby>学習<rt>がくしゅう</rt></ruby><ruby>プラットフォーム<rt>ぷらっとふぉーむ</rt></ruby>',
            subtitle: '<ruby>対話型<rt>たいわがた</rt></ruby><ruby>ウェブ<rt>うぇぶ</rt></ruby><ruby>アプリケーション<rt>あぷりけーしょん</rt></ruby>',
            description: '<ruby>みんなの<rt>みんなの</rt></ruby><ruby>日本語<rt>にほんご</rt></ruby><ruby>教科書<rt>きょうかしょ</rt></ruby><ruby>シリーズ<rt>しりーず</rt></ruby>の<ruby>文法<rt>ぶんぽう</rt></ruby><ruby>パターン<rt>ぱたーん</rt></ruby>を<ruby>学習<rt>がくしゅう</rt></ruby>するための<ruby>対話型<rt>たいわがた</rt></ruby><ruby>ウェブ<rt>うぇぶ</rt></ruby><ruby>アプリケーション<rt>あぷりけーしょん</rt></ruby>です。<ruby>例文<rt>れいぶん</rt></ruby>、<ruby>翻訳<rt>ほんやく</rt></ruby>、<ruby>イラスト<rt>いらすと</rt></ruby>を<ruby>含<rt>ふく</rt></ruby>む<ruby>使い<rt>つか</rt></ruby>やすい<ruby>インターフェース<rt>いんたーふぇーす</rt></ruby>を<ruby>提供<rt>ていきょう</rt></ruby>いたします。',
            features: [
              '<ruby>レッスン<rt>れっすん</rt></ruby>ごとの<ruby>文法<rt>ぶんぽう</rt></ruby><ruby>パターン<rt>ぱたーん</rt></ruby>の<ruby>閲覧<rt>えつらん</rt></ruby>',
              '<ruby>振<rt>ふ</rt></ruby>り<ruby>仮名<rt>がな</rt></ruby>つきの<ruby>日本語<rt>にほんご</rt></ruby><ruby>例文<rt>れいぶん</rt></ruby>の<ruby>表示<rt>ひょうじ</rt></ruby>',
              '<ruby>英語<rt>えいご</rt></ruby>、<ruby>ヒンディー語<rt>ひんでぃーご</rt></ruby>、<ruby>テルグ語<rt>てるぐご</rt></ruby>での<ruby>翻訳<rt>ほんやく</rt></ruby>',
              '<ruby>各<rt>かく</rt></ruby><ruby>文法<rt>ぶんぽう</rt></ruby><ruby>パターン<rt>ぱたーん</rt></ruby>の<ruby>イラスト<rt>いらすと</rt></ruby><ruby>説明<rt>せつめい</rt></ruby>',
              '<ruby>デスクトップ<rt>ですくとっぷ</rt></ruby>と<ruby>モバイル<rt>もばいる</rt></ruby><ruby>端末<rt>たんまつ</rt></ruby>の<ruby>レスポンシブ<rt>れすぽんしぶ</rt></ruby><ruby>デザイン<rt>でざいん</rt></ruby>',
              '<ruby>特定<rt>とくてい</rt></ruby>の<ruby>文法<rt>ぶんぽう</rt></ruby><ruby>パターン<rt>ぱたーん</rt></ruby>を<ruby>検索<rt>けんさく</rt></ruby>する<ruby>機能<rt>きのう</rt></ruby>'
            ],
            tech: [
              'React',
              'Next.js',
              'Javascript',
              'Tailwind CSS',
              'Vercel',
              'i18n',
              'Framer Motion'
            ],
            demo: {
              web: 'https://japanese-grammar.vercel.app/'
            },
            github: 'https://github.com/suresh2291/japanese-grammar',
            isHighlighted: true
          },
          {
            title: '<ruby>データベース<rt>でーたべーす</rt></ruby><ruby>移行<rt>いこう</rt></ruby><ruby>ツール<rt>つーる</rt></ruby>',
            subtitle: 'MySQL から TimescaleDB への<ruby>移行<rt>いこう</rt></ruby><ruby>ユーティリティ<rt>ゆーてぃりてぃ</rt></ruby>',
            description: '<ruby>汎用<rt>はんよう</rt></ruby><ruby>データベース<rt>でーたべーす</rt></ruby><ruby>移行<rt>いこう</rt></ruby>と<ruby>特化<rt>とっか</rt></ruby>したTimescaleDB<ruby>移行<rt>いこう</rt></ruby>の<ruby>両方<rt>りょうほう</rt></ruby>を<ruby>サポート<rt>さぽーと</rt></ruby>する<ruby>強力<rt>きょうりょく</rt></ruby>で<ruby>柔軟<rt>じゅうなん</rt></ruby>な<ruby>移行<rt>いこう</rt></ruby><ruby>ツール<rt>つーる</rt></ruby>です。<ruby>増分<rt>ぞうぶん</rt></ruby><ruby>同期<rt>どうき</rt></ruby>と<ruby>進捗<rt>しんちょく</rt></ruby><ruby>追跡<rt>ついせき</rt></ruby>を<ruby>サポート<rt>さぽーと</rt></ruby>し、<ruby>異<rt>こと</rt></ruby>なる<ruby>データベース<rt>でーたべーす</rt></ruby><ruby>システム<rt>しすてむ</rt></ruby>間の<ruby>シームレス<rt>しーむれす</rt></ruby>な<ruby>データ<rt>でーた</rt></ruby><ruby>転送<rt>てんそう</rt></ruby>を<ruby>実現<rt>じつげん</rt></ruby>いたします。',
            features: [
              '<ruby>汎用<rt>はんよう</rt></ruby><ruby>データベース<rt>でーたべーす</rt></ruby><ruby>移行<rt>いこう</rt></ruby>の<ruby>サポート<rt>さぽーと</rt></ruby>（MySQL、PostgreSQL）',
              'TimescaleDB<ruby>特化<rt>とっか</rt></ruby>の<ruby>移行<rt>いこう</rt></ruby><ruby>機能<rt>きのう</rt></ruby>',
              '<ruby>増分<rt>ぞうぶん</rt></ruby><ruby>データ<rt>でーた</rt></ruby><ruby>同期<rt>どうき</rt></ruby>',
              '<ruby>進捗<rt>しんちょく</rt></ruby><ruby>追跡<rt>ついせき</rt></ruby>と<ruby>チェックポイント<rt>ちぇっくぽいんと</rt></ruby>',
              '<ruby>詳細<rt>しょうさい</rt></ruby>な<ruby>ログ<rt>ろぐ</rt></ruby><ruby>システム<rt>しすてむ</rt></ruby>',
              '<ruby>設定<rt>せってい</rt></ruby><ruby>可能<rt>かのう</rt></ruby>な<ruby>移行<rt>いこう</rt></ruby><ruby>プロセス<rt>ぷろせす</rt></ruby>',
              '<ruby>大規模<rt>だいきぼ</rt></ruby><ruby>データ<rt>でーた</rt></ruby><ruby>移行<rt>いこう</rt></ruby>の<ruby>サポート<rt>さぽーと</rt></ruby>',
              '<ruby>データ<rt>でーた</rt></ruby><ruby>損失<rt>そんしつ</rt></ruby>ゼロの<ruby>保証<rt>ほしょう</rt></ruby>',
              '<ruby>一括<rt>いっかつ</rt></ruby><ruby>転送<rt>てんそう</rt></ruby>のための<ruby>性能<rt>せいのう</rt></ruby><ruby>最適化<rt>さいてきか</rt></ruby>'
            ],
            tech: [
              'Node.js',
              'Javascript',
              'MySQL',
              'PostgreSQL',
              'TimescaleDB',
              'Docker',
              'AWS DMS',
              '<ruby>データ<rt>でーた</rt></ruby><ruby>検証<rt>けんしょう</rt></ruby>'
            ],
            github: 'https://github.com/suresh2291/mysql-timescale-migrate',
            isHighlighted: true
          },
          {
            title: '<ruby>画像<rt>がぞう</rt></ruby><ruby>注釈<rt>ちゅうしゃく</rt></ruby><ruby>アップ</ruby>',
            subtitle: 'フルスタック MERN <ruby>アプリケーション</ruby>',
            description: '<ruby>画像<rt>がぞう</rt></ruby>の<ruby>共有<rt>きょうゆう</rt></ruby>、<ruby>注釈<rt>ちゅうしゃく</rt></ruby>、<ruby>ダウンロード</ruby>のための<ruby>総合<rt>そうごう</rt></ruby><ruby>プラットフォーム</ruby>です。<ruby>ユーザー</ruby><ruby>認証<rt>にんしょう</rt></ruby>、<ruby>ソーシャル</ruby><ruby>機能<rt>きのう</rt></ruby>、<ruby>画像<rt>がぞう</rt></ruby><ruby>強化<rt>きょうか</rt></ruby>などの<ruby>高度<rt>こうど</rt></ruby>な<ruby>機能<rt>きのう</rt></ruby>を<ruby>提供<rt>ていきょう</rt></ruby>します。',
            features: [
              '<ruby>画像<rt>がぞう</rt></ruby><ruby>注釈<rt>ちゅうしゃく</rt></ruby>と<ruby>ダウンロード</ruby><ruby>機能<rt>きのう</rt></ruby>',
              '<ruby>完全<rt>かんぜん</rt></ruby>な<ruby>ユーザー</ruby><ruby>認証<rt>にんしょう</rt></ruby><ruby>システム</ruby>',
              '<ruby>ソーシャル</ruby><ruby>機能<rt>きのう</rt></ruby>（いいね、<ruby>コメント</ruby>、フォロー）',
              '<ruby>友達<rt>ともだち</rt></ruby><ruby>申請<rt>しんせい</rt></ruby><ruby>システム</ruby>',
              '<ruby>プロフィール</ruby><ruby>管理<rt>かんり</rt></ruby>',
              '<ruby>暗<rt>くら</rt></ruby>/<ruby>明<rt>あか</rt></ruby><ruby>モード</ruby><ruby>切替<rt>きりかえ</rt></ruby>'
            ],
            tech: [
              'JavaScript',
              'Node.js',
              'MongoDB',
              'React',
              'React-Konva',
              'AWS',
              'Cloudinary',
              'FastQ',
              'JWT',
              'Mongoose',
              'Multer',
              'Nodemailer',
              'Sharp'
            ],
            demo: {
              web: 'https://www.youtube.com/watch?v=cKUMCm4lB24',
              mobile: 'https://www.youtube.com/watch?v=wA3FKxYxkMw'
            },
            github: 'https://github.com/suresh2291/photoSharingApp',
            isHighlighted: true
          },
          {
            title: 'React <ruby>画像<rt>がぞう</rt></ruby><ruby>注釈<rt>ちゅうしゃく</rt></ruby><ruby>ツール</ruby>',
            subtitle: 'NPM <ruby>パッケージ</ruby>',
            description: '<ruby>直感的<rt>ちょっかんてき</rt></ruby>な<ruby>操作<rt>そうさ</rt></ruby><ruby>性<rt>せい</rt></ruby>を<ruby>備<rt>そな</rt></ruby>えた<ruby>画像<rt>がぞう</rt></ruby><ruby>注釈<rt>ちゅうしゃく</rt></ruby><ruby>機能<rt>きのう</rt></ruby>を<ruby>提供<rt>ていきょう</rt></ruby>する React <ruby>用<rt>よう</rt></ruby>の NPM <ruby>パッケージ</ruby>です。',
            features: [
              '<ruby>画像<rt>がぞう</rt></ruby><ruby>ファイル</ruby><ruby>選択<rt>せんたく</rt></ruby><ruby>機能<rt>きのう</rt></ruby>',
              '<ruby>複数<rt>ふくすう</rt></ruby>の<ruby>フォント</ruby><ruby>選択肢<rt>せんたくし</rt></ruby>',
              '<ruby>文字<rt>もじ</rt></ruby>と<ruby>円<rt>えん</rt></ruby>の<ruby>サイズ</ruby><ruby>調整<rt>ちょうせい</rt></ruby>',
              '<ruby>色<rt>いろ</rt></ruby><ruby>選択<rt>せんたく</rt></ruby><ruby>機能<rt>きのう</rt></ruby>',
              '<ruby>手書<rt>てが</rt></ruby>き<ruby>描画<rt>びょうが</rt></ruby><ruby>機能<rt>きのう</rt></ruby>',
              '<ruby>元<rt>もと</rt></ruby>に<ruby>戻<rt>もど</rt></ruby>す/<ruby>やり直<rt>やりなお</rt></ruby>し<ruby>機能<rt>きのう</rt></ruby>'
            ],
            tech: [
              'React',
              'JavaScript',
              'NPM',
              'ReactKonva',
              'HTML5',
              'CSS3'
            ],
            links: {
              npm: 'https://www.npmjs.com/package/react-image-annotate-tool'
            },
            github: 'https://github.com/suresh2291/react-image-annomate',
            isHighlighted: true
          },
          {
            title: '<ruby>データベース</ruby><ruby>移行<rt>いこう</rt></ruby><ruby>ツール</ruby>',
            subtitle: 'MySQL から MongoDB への<ruby>移行<rt>いこう</rt></ruby><ruby>ユーティリティ</ruby>',
            description: 'MySQL から MongoDB への<ruby>データ</ruby><ruby>変換<rt>へんかん</rt></ruby>と<ruby>転送<rt>てんそう</rt></ruby>を<ruby>自動化<rt>じどうか</rt></ruby>する<ruby>ツール</ruby>です。<ruby>データ型<rt>がた</rt></ruby>の<ruby>変換<rt>へんかん</rt></ruby>、<ruby>関係<rt>かんけい</rt></ruby><ruby>マッピング</ruby>、<ruby>データ</ruby><ruby>整合性<rt>せいごうせい</rt></ruby>の<ruby>確認<rt>かくにん</rt></ruby>を<ruby>行<rt>おこな</rt></ruby>います。',
            features: [
              'SQL から MongoDB <ruby>スキーマ</ruby>への<ruby>自動<rt>じどう</rt></ruby><ruby>変換<rt>へんかん</rt></ruby>',
              '<ruby>データ型<rtがた</rt></ruby><ruby>マッピング<rt>まっぴんぐ</rt></ruby>と<ruby>変換<rt>へんかん</rt></ruby>',
              '<ruby>コレクション</ruby>間の<ruby>関係<rt>かんけい</rt></ruby><ruby>保持<rt>ほじ</rt></ruby>',
              '<ruby>設定<rt>せってい</rt></ruby><ruby>可能<rt>かのう</rt></ruby>な<ruby>移行<rt>いこう</rt></ruby><ruby>設定<rt>せってい</rt></ruby>',
              '<ruby>進捗<rt>しんちょく</rt></ruby><ruby>管理<rt>かんり</rt></ruby>と<ruby>ログ<rt>ろぐ</rt></ruby><ruby>記録<rt>きろく</rt></ruby>'
            ],
            tech: [
              'Node.js',
              'MySQL',
              'MongoDB',
              'JSON',
              'mongodb',
              'mysql',
              'SQL Parser',
              'Data Validation'
            ],
            github: 'https://github.com/suresh2291/datamigration',
            isHighlighted: true
          },
          {
            title: 'CoderByte <ruby>解答集<rt>かいとうしゅう</rt></ruby>',
            subtitle: 'JavaScript <ruby>アルゴリズム</ruby><ruby>課題<rt>かだい</rt></ruby>',
            description: 'CoderByte の<ruby>プログラミング</ruby><ruby>課題<rt>かだい</rt></ruby>に<ruby>対<rt>たい</rt></ruby>する JavaScript <ruby>解答<rt>かいとう</rt></ruby>の<ruby>包括的<rt>ほうかつてき</rt></ruby>な<ruby>集合<rt>しゅうごう</rt></ruby>です。<ruby>問題解決<rt>もんだいかいけつ</rt></ruby><ruby>能力<rt>のうりょく</rt></ruby>と<ruby>アルゴリズム</ruby><ruby>的思考<rt>てきしこう</rt></ruby>を<ruby>示<rt>しめ</rt></ruby>します。',
            features: [
              '<ruby>配列<rt>はいれつ</rt></ruby><ruby>操作<rt>そうさ</rt></ruby><ruby>アルゴリズム</ruby>',
              '<ruby>文字列<rt>もじれつ</rt></ruby><ruby>処理<rt>しょり</rt></ruby><ruby>解法<rt>かいほう</rt></ruby>',
              '<ruby>数学的<rt>すうがくてき</rt></ruby><ruby>問題<rt>もんだい</rt></ruby><ruby>実装<rt>じっそう</rt></ruby>',
              '<ruby>データ</ruby><ruby>構造<rt>こうぞう</rt></ruby><ruby>課題<rt>かだい</rt></ruby>'
            ],
            tech: [
              'JavaScript',
              'Data Structures',
              'Algorithms',
              'Problem Solving',
              'ES6+',
              'Jest'
            ],
            github: 'https://github.com/suresh2291/coderByteJs',
            isHighlighted: true
          },
          {
            title: 'REST API Todo <ruby>アプリ</ruby>',
            subtitle: 'Node.js <ruby>バックエンド</ruby><ruby>アプリケーション</ruby>',
            description: 'Node.js と Express を<ruby>使用<rt>しよう</rt></ruby>した Todo <ruby>アプリケーション</ruby>の RESTful API <ruby>実装<rt>じっそう</rt></ruby>です。API <ruby>設計<rt>せっけい</rt></ruby>、<ruby>認証<rt>にんしょう</rt></ruby>、<ruby>データベース</ruby><ruby>統合<rt>とうごう</rt></ruby>の<ruby>ベべすとぷらくてぃす</rt></ruby>を<ruby>実証<rt>じっしょう</rt></ruby>します。',
            features: [
              'RESTful API <ruby>設計<rt>せっけい</rt></ruby>',
              'Todo <ruby>基本<rt>きほん</rt></ruby><ruby>操作<rt>そうさ</rt></ruby>',
              '<ruby>ユーザー</ruby><ruby>認証<rt>にんしょう</rt></ruby>と<ruby>認可<rt>にんか</rt></ruby>',
              '<ruby>入力<rt>にゅうりょく</rt></ruby><ruby>検証<rt>けんしょう</rt></ruby>と<ruby>サニタイズ</ruby>',
              '<ruby>エラー</ruby><ruby>処理<rt>しょり</rt></ruby>'
            ],
            tech: [
              'Node.js',
              'Express',
              'MongoDB',
              'JWT',
              'Mongoose',
              'bcrypt',
              'Swagger UI',
              'Jest'
            ],
            github: 'https://github.com/suresh2291/nodeJsTodoAPP',
            isHighlighted: true
          }
        ]
      },
      contact: {
        title: '<ruby>お問<rt>とい</rt></ruby>い<ruby>合<rt>あ</rt></ruby>わせ',
        name: 'アムルタム・スレーシュ'
      },
      navigation: {
        menu: {
          home: '<ruby>ホーム</ruby>',
          about: '<ruby>自己<rt>じこ</rt></ruby><ruby>紹介<rt>しょうかい</rt></ruby>',
          experience: '<ruby>職務<rt>しょくむ</rt></ruby><ruby>経歴<rt>けいれき</rt></ruby>',
          skills: '<ruby>技術<rt>ぎじゅつ</rt></ruby><ruby>専門<rt>せんもん</rt></ruby><ruby>分野<rt>ぶんや</rt></ruby>',
          projects: '<ruby>個人<rt>こじん</rt></ruby><ruby>開発<rt>かいはつ</rt></ruby>',
          contact: '<ruby>お問<rt>とい</rt></ruby>い<ruby>合<rt>あ</rt></ruby>わせ'
        },
        language: {
          select: '<ruby>言語<rt>げんご</rt></ruby>を<ruby>選択<rt>せんたく</rt></ruby>',
          en: '<ruby>英語<rt>えいご</rt></ruby>',
          ja: '<ruby>日本語<rt>にほんご</rt></ruby>'
        },
        theme: {
          toggle: '<ruby>テーマ<rt>てーま</rt></ruby>を<ruby>切り替<rt>きりかえ</rt></ruby>える',
          light: '<ruby>ライト<rt>らいと</rt></ruby><ruby>モード<rt>もーど</rt></ruby>',
          dark: '<ruby>ダーク<rt>だーく</rt></ruby><ruby>モード<rt>もーど</rt></ruby>'
        }
      }
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;